import KeyIcon from '@heroicons/react/24/solid/KeyIcon';
import ChartBarIcon from '@heroicons/react/24/solid/ChartBarIcon';
import CogIcon from '@heroicons/react/24/solid/CogIcon';
import LockClosedIcon from '@heroicons/react/24/solid/LockClosedIcon';
import ShoppingBagIcon from '@heroicons/react/24/solid/ShoppingBagIcon';
import UserIcon from '@heroicons/react/24/solid/UserIcon';
import UserPlusIcon from '@heroicons/react/24/solid/UserPlusIcon';
import UsersIcon from '@heroicons/react/24/solid/UsersIcon';
import XCircleIcon from '@heroicons/react/24/solid/XCircleIcon';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import QrCodeIcon from '@mui/icons-material/QrCode';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import BadgeIcon from '@mui/icons-material/Badge';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import AssessmentIcon from '@mui/icons-material/Assessment';
import { SvgIcon } from '@mui/material';
import { useAuth } from '../../App'; // adjust path

// ---------- helpers ----------
function icon(node) { return <SvgIcon fontSize='small'>{node}</SvgIcon>; }
function hasRole(rolesSet, role) { return rolesSet.has('All') || rolesSet.has(role); }

// small menu factories
function visitorMenuBasic() { return { title: 'Visitor Management', path: '/visitors', icon: icon(<GroupAddIcon />), children: [{ path: '/visitor/-1', title: 'New Visitor', icon: icon(<GroupAddIcon />) }] }; }
function visitorMenuFull()  { return { title: 'Visitor Management', path: '/visitors', icon: icon(<GroupAddIcon />), children: [{ path: '/visitors', title: 'Visitor List', icon: icon(<GroupAddIcon />) }, { path: '/preregister/-1', title: 'Pre Register Visitor', icon: icon(<GroupAddIcon />) }, { path: '/visitor/-1', title: 'New Visitor', icon: icon(<GroupAddIcon />) }] }; }
function reportsGeneral()    { return { }} //title: 'Reports', path: '/reports', icon: icon(<AssessmentIcon />) }; }
function reportsStaff()      { return { }} // title: 'Reports Staff', path: '/reports-staff', icon: icon(<AssessmentIcon />) }; }
function busManagement()     { return { }} // title: 'Bus Management', path: '/bus', icon: icon(<AssessmentIcon />) }; }
function busReports()        { return { }} // title: 'Bus Reports', path: '/reports-bus', icon: icon(<AssessmentIcon />) }; }
function studentSummary()    { return { }} // title: 'Student CheckIn/CheckOut', path: '/student-summary', icon: icon(<AssessmentIcon />) }; }
function historicalReports() { return { }} // title: 'Student CheckIn/CheckOut - History', path: '/historical-reports', icon: icon(<AssessmentIcon />) }; }
function staffSummary()      { return { }} // title: 'Staff Summary', path: '/staff-summary', icon: icon(<AssessmentIcon />) }; }
function checkIn()           { return { }} // title: 'RFID Check-in', path: '/manual', icon: icon(<DocumentScannerIcon />) }; }
function checkOut()          { return { }} // title: 'RFID Check-out', path: '/manualout', icon: icon(<DocumentScannerIcon />) }; }
function checkInReports()    { return { }} // title: 'Check-In Reports', path: '/reports', icon: icon(<AssessmentIcon />) }; }
function checkOutReports()   { return { }} // title: 'Check-Out Reports', path: '/reportsout', icon: icon(<AssessmentIcon />) }; }
function tempIdMgmt()        { return { title: 'Temp ID Management', path: '/tempid', icon: icon(<AssessmentIcon />) }; }
function tempIdReports()     { return { title: 'Temp ID Reports', path: '/tempidreports', icon: icon(<AssessmentIcon />) }; }
function decalRequests()     { return { title: 'Decal Requests', path: '/decal', icon: icon(<LocalShippingIcon />) }; }
function selfAttestation()   { return { title: 'Self Attestation', path: '/self-attestation', icon: icon(<AssessmentIcon />) }; }
function attestationForm()   { return { }} // title: 'View Attestations', path: '/att-form', icon: icon(<AssessmentIcon />) }; }
function viewAttestation()   { return { }} // title: 'Attestation Form', path: '/view-attestation', icon: icon(<AssessmentIcon />) }; }
function myAttendance() { return { }} // title: 'My Attendance', path: '/my-attendance', icon: icon(<AssessmentIcon />) }; }
function visitorReport() { return { title: 'Visitor Reports', path: '/visitor-reports', icon: icon(<AssessmentIcon />) }; }
function faceConsent() { return { }} // title: 'Face Data Consent', path: '/face-consent', icon: icon(<AssessmentIcon />) }; }
//function pinLookup() { return { }} // title: 'PIN Lookup', path: '/pin-lookup', icon: icon(<BadgeIcon />) }; }
function pinLookup() { return { title: 'PIN Lookup', path: '/pin-lookup', icon: icon(<AssessmentIcon />) }; }

export const PRINCIPAL_ROLES = [
  'Secondary Associate Principal & AP/IB Coordinator',
  'High School Principal',
  'Middle School Principal',
  'Secondary Associate Principal for Student Life',
  'Elementary School Principal',
  'ES Associate Principal'
];

function isPrincipal(rolesSet) {
  if (rolesSet.has('All') || rolesSet.has('Principal')) return true;
  return PRINCIPAL_ROLES.some(function(r){ return rolesSet.has(r); });
}

// core builder used by both exports
export function buildMenu(rolesSet, section) {
  // Principal
  if (hasRole(rolesSet, 'Principal')) 
  {
    return [ faceConsent(), pinLookup(), visitorMenuBasic(), checkIn(), checkOut(), checkInReports(), checkOutReports(), tempIdMgmt(), tempIdReports(), decalRequests(), selfAttestation(), visitorMenuFull(), visitorReport() ];
  }
  
  // Secretaries (explicit titles you listed)
  if (
    hasRole(rolesSet, 'Admin Asst - HS Principal\'s Office and IB&AP Coordinator') ||
    hasRole(rolesSet, 'HS Registrar & Admin Assistant to the HS Counselors') ||
    hasRole(rolesSet, 'Admin. Asst. to MS Principal') ||
    hasRole(rolesSet, 'Secretary to MS Counselor') ||
    hasRole(rolesSet, 'Admin Asst - ES Principal\'s Office') ||
    hasRole(rolesSet, 'Senior Admin. Assistant. - ES Principal')
  ) {
    return [
      studentSummary(),
      historicalReports()
      // if you want section-specific report pages, uncomment:
      // section === 'MS' ? reportsMS() : section === 'ES' ? reportsES() : section === 'HS' ? reportsHS() : reportsGeneral()
      // , busReports()
    ];
  }

  // Senior Web Developer (your custom staff role)
  if (hasRole(rolesSet, 'Data and Information Systems Director') || hasRole(rolesSet, 'Senior Web Developer') || hasRole(rolesSet, 'all')) {
    return [
      faceConsent(),
      pinLookup(), 
      visitorMenuFull(),
      tempIdMgmt(),
      tempIdReports(),
      decalRequests(),
      visitorReport(),
      selfAttestation()
      //attestationForm(),
      //viewAttestation()
    ];
  }
  
  // Security PIN lookup only
  if (hasRole(rolesSet, 'Security')) {
    return [ pinLookup() ];
  }
  // Vendor
  if (hasRole(rolesSet, 'Vendor')) {
    return [ visitorMenuBasic() ];
  }

  if (hasRole(rolesSet, 'HR Associate Director')) {
    return [ staffSummary(), checkInReports(), checkOutReports() ];
  }

  if (hasRole(rolesSet, 'Systems Administrator / R&D Coordinator')) {
    return [ checkInReports(), checkOutReports() ];
  }

  if (hasRole(rolesSet, 'IT Manager')) {
    return [ checkInReports(), checkOutReports() ];
  }

  // Manager
  if (hasRole(rolesSet, 'Facilities Manager')) {
    return [ studentSummary(), historicalReports() ];
  }

  if (hasRole(rolesSet, 'Head of School')) {
    return [ studentSummary(), historicalReports() ];
  }

  if (isPrincipal(rolesSet)) {
    return [ studentSummary(), historicalReports() ];
  }

  // Default (general user)
  return [
    /*checkIn(),
    checkOut(),
    studentSummary(),
    historicalReports(),
    staffSummary(),
    checkInReports(),
    checkOutReports(),
    visitorMenuFull(),
    tempIdMgmt(),
    tempIdReports(),
    decalRequests(),
    selfAttestation()
    myAttendance()*/
  ];
}

// ---------- REACTIVE export (preferred) ----------
export function useMenuItems() {
  const { user } = useAuth();               // from AuthProvider
  if (user === undefined) return [];         // loading: render nothing or a skeleton
  if (!user) return [];                      // logged out

  const roles = new Set(user.roles || []);   // treat 'All' in guards
  const section = (user.section || '').toUpperCase();
  return buildMenu(roles, section);
}

// ---------- LEGACY static export (keeps current imports working) ----------
function safeParse(raw) { try { return JSON.parse(raw); } catch (e) { return null; } }
function rolesAndSectionFromStorage() {
  var roles = new Set();
  var section = '';

  var ud = safeParse(localStorage.getItem('userData'));
  if (ud && Array.isArray(ud.roles)) {
    roles = new Set(ud.roles);
    section = (ud.section || '').toUpperCase();
  } else {
    var r = safeParse(localStorage.getItem('userRole'));
    var s = safeParse(localStorage.getItem('userSection'));
    if (Array.isArray(r)) roles = new Set(r);
    else if (typeof r === 'string') {
      roles = r.toLowerCase() === 'all'
        ? new Set(['All'])
        : new Set(r.split(',').map(function(x){ return x.trim(); }).filter(Boolean));
    }
    section = (s || '').toUpperCase();
  }
  return { roles: roles, section: section };
}

const _ls = rolesAndSectionFromStorage();
export const items = buildMenu(_ls.roles, _ls.section);